import { useRef, useState } from 'react';
import useModal from 'components/Modals/useModal';
import { MaybeInputControl } from '../InputControl';
import Validation, { useValidation } from '../Validation';
import { UnderlineInputLayout } from '../TextInput/Underline';
import { useKeyBoardContext } from 'hooks/keyboardEventHandler/useKeyBoardContext';
import { SummaryInputWrapper } from './styles';
import { SummarizedPlaceholder } from './SummarizedPlaceholder';
import { SummarizedMultiSelectModal } from './Modal';
import { EMPTY_OBJECT } from 'utility/fieldHelpers';

const UnderlineSummarizedMultiSelect = (props) => {
  const validationRef = useRef();
  const [validation, validationProps] = useValidation(validationRef, props);
  const {
    field,
    access,
    entityId,
    fieldId,
    onChange,
    inModal = false,
    errorPlacement,
    error = EMPTY_OBJECT,
    showVisibleIcon = true,
    checkConflictingPrimaryRelationship = false,
    ...inputControlProps
  } = props;

  const { disabled: disabledProp, value, viewable = true } = props;

  const { assignFieldHandle } = useKeyBoardContext();

  const [focused, setFocused] = useState(false);
  const [modalProps, , modal] = useModal();
  const disabled = disabledProp && !viewable;
  const buttonRef = useRef(null);
  assignFieldHandle(fieldId, {
    customFocus: () => {
      buttonRef.current?.focus();
      return buttonRef.current;
    },
    disabled,
  });

  return (
    <>
      <MaybeInputControl
        forInput
        variant="underline"
        {...{
          ...inputControlProps,
          error: true,
          disabled: true,
          shrink: true,
        }}
      >
        <UnderlineInputLayout
          ref={validationRef}
          disabled={disabled}
          viewable={viewable}
          error={error || validation.error}
          focused={focused}
        >
          <SummaryInputWrapper
            ref={buttonRef}
            onClick={() => (!disabledProp || viewable) && modal.show()}
            disabled={disabled}
            showVisibleIcon={showVisibleIcon}
            onFocus={() => setFocused(true)}
            onBlur={() => setFocused(false)}
          >
            <SummarizedPlaceholder
              {...value}
              field={field}
              showVisibleIcon={showVisibleIcon && (!disabledProp || viewable)}
            />
          </SummaryInputWrapper>
        </UnderlineInputLayout>
        <Validation
          inModal={inModal}
          errorPlacement={errorPlacement}
          {...validationProps}
        />
      </MaybeInputControl>
      {modalProps.show && (
        <SummarizedMultiSelectModal
          show
          field={field}
          access={access}
          entityId={entityId}
          onChange={onChange}
          modalProps={modalProps}
          readOnly={disabledProp}
          value={value}
          checkConflictingPrimaryRelationship={
            checkConflictingPrimaryRelationship
          }
        />
      )}
    </>
  );
};

export default UnderlineSummarizedMultiSelect;
